import { Button, Collapse, Form, Layout, Typography } from "antd";
import {
  EXISTING_PO_MAP_LIST,
  GET_PACKING_PRODUCT_ENDPOINT,
  PACKING_CONFIRM,
  PACKING_CONFIRMATION_LIST,
  HOURLY_PACKING_EDIT_ENDPOINT,
  HOURLY_PACKING_UPDATE_ENDPOINT,
  PACKING_LINES_ENDPOINT,
  PACKING_TABLE_ENDPOINT,
  GET_DIGITALIZATION_APP_USERS,
  SALES_CONTRACT_LIST,
  GET_BUYING_OFFICE_ENDPOINT,
  GET_BUYER_ENDPOINT,
} from "apiServices/API_ENDPOINTS";
import { getData, postData } from "apiServices/common";
import { alertPop } from "apiServices/common/helper";
import HandleNotification from "common/Notification";
import AppPageHeader from "common/PageHeader";
import InventoryLayOutCommon from "components/InventoryFabric/LayOut/InventoryLayOutCommon";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router";
import { PACKING_CREATE_PERMISSION, PACKING_EDIT_PERMISSION } from "routes/permissions";
import { hasPermission } from "utils/functions";
import HourlyPackingConfirmationForm from "./HourlyPackingConfirmationForm";
import HourlyPackingConfirmationTable from "./HourlyPackingConfirmationTable";

const HourlyPackingConfirmation = (props) => {
  // Props
  const { isEdit } = props;
  const { id } = useParams() || {};
  const navigate = useNavigate();

  // States
  const [poList, setPoList] = useState(null);
  const [cartonList, setCartonList] = useState(null);
  const [selectedCarton, setSelectedCarton] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFactory, setIsFactory] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [loading, setLoading] = useState(false);

  // Dropdown lists
  const [packingLinesList, setPackingLinesList] = useState([]);
  const [packingTablesList, setPackingTablesList] = useState([]);
  const [operatorsList, setOperatorsList] = useState([]);
  const [salesContractList, setSalesContractList] = useState([]);
  const [buyingOfficeList, setBuyingOfficeList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);

  // Antd
  const { Content } = Layout;
  const { Panel } = Collapse;
  const { Title } = Typography;
  const [PackConfirmForm] = Form.useForm();
  const po_map_id_watch = Form.useWatch("po_map_id", PackConfirmForm);
  const start_watch = Form.useWatch("start", PackConfirmForm);
  const end_watch = Form.useWatch("end", PackConfirmForm);
  const packing_date_watch = Form.useWatch("packing_date", PackConfirmForm);
  const buyer_id_watch = Form.useWatch("buyer_id", PackConfirmForm);

  // Router
  const location = useLocation();

  console.log("selectedCarton", selectedCarton);

  const extra = (
    <div className="extra-button-container">
      <Button
        htmlType="submit"
        type="primary"
        size="small"
        style={{ marginRight: 5 }}
        onClick={() => PackConfirmForm.submit()}
        disabled={
          (isEdit && !hasPermission([PACKING_EDIT_PERMISSION])) ||
          (!isEdit && !hasPermission([PACKING_CREATE_PERMISSION])) ||
          isSubmitting ||
          loading
        }
        loading={isSubmitting || loading}
      >
        {isEdit
          ? hasPermission([PACKING_EDIT_PERMISSION])
            ? "Update"
            : "No Permission"
          : hasPermission([PACKING_CREATE_PERMISSION])
          ? "Submit"
          : "No Permission"}
      </Button>
      <Button
        size="small"
        onClick={() => {
          if (isEdit) {
            navigate("/digitalization/packing/confirmation");
          } else {
            PackConfirmForm.resetFields();
          }
        }}
      >
        {isEdit ? "Back" : "Reset"}
      </Button>
    </div>
  );

  const getPOList = async () => {
    const query = `${EXISTING_PO_MAP_LIST}`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      setPoList(response?.data?.data);
    } else {
      alertPop("error", "Something went wrong");
    }
  };

  const getPackingProductInfo = useCallback(
    async ({
      po_map_id,
      sales_contract_id,
      buying_office_id,
      transaction_no_per_day,
      packing_date,
      sub_contract_factory_id,
    }) => {
      const bodyData = {
        po_map_id: po_map_id ? Number(po_map_id) : null,
        sub_contract_factory_id: sub_contract_factory_id ? Number(sub_contract_factory_id) : null,
        sales_contract_id: sales_contract_id ? Number(sales_contract_id) : null,
        buying_office_id: buying_office_id ? Number(buying_office_id) : null,
        packing_date: packing_date ? moment(packing_date).format("YYYY-MM-DD") : null,
        transaction_no_per_day: transaction_no_per_day ? Number(transaction_no_per_day) : null,
      };

      const query = `${GET_PACKING_PRODUCT_ENDPOINT}`;

      const response = await postData(query, bodyData);

      if (response && response?.code === 200) {
        const form_data = response?.data?.form_data;
        const table_data = response?.data?.table_data?.map((data) => ({
          ...data,
          carton_id: data?.id,
          status: String(data?.status),
        }));

        const carton_nos = table_data?.map((data) => data?.carton_no);
        const max_carton_no = Math.max(...carton_nos);
        const min_carton_no = Math.min(...carton_nos);

        // Set form data
        PackConfirmForm.setFieldsValue({
          original_po: form_data?.po_map?.original_po,
          internal_po: form_data?.po_map?.internal_po,
          buying_office_id: form_data?.buying_office?.id,
          buying_office_name: form_data?.buying_office?.name,
          buyer_id: form_data?.buyer?.id,
          buyer_name: form_data?.buyer?.name,
          sales_contract_id: form_data?.sales_contract?.id,
          po_map_id: form_data?.po_map?.id,
          reference_no: form_data?.sales_contract?.reference_no,
          start: min_carton_no,
          end: max_carton_no,
          packing_date: packing_date ? moment(packing_date) : moment(),
          sub_contract_factory_id: form_data?.sub_contract_factory?.id,
          sub_contract_factory_name: form_data?.sub_contract_factory?.name || "",
        });
        setIsFactory(form_data?.sub_contract_factory?.id ? true : false);

        setCartonList(table_data);
        // check if the status == 1 set selectedCarton
        const selectedCarton = table_data
          ?.filter((carton) => carton?.status === "1" || carton?.status === "2")
          ?.map((carton) => ({
            ...carton,
            carton_id: carton?.carton_id,
            status: String(carton?.status),
          }));
        setSelectedCarton(selectedCarton);
      } else {
        HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
      }
    },
    // Ignored dependencies to stop loop
    [PackConfirmForm],
  );

  // Fetch dropdown data
  const getPackingLines = useCallback(async (searchValue = null) => {
    const bodyData = {
      ...(searchValue && { name: searchValue }),
      page: 1,
      per_page: 100,
    };
    const response = await getData(PACKING_LINES_ENDPOINT, false, bodyData);
    if (response?.status === 200 || response?.code === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setPackingLinesList(data);
    }
  }, []);

  const getPackingTables = useCallback(async (packingLineId = null, searchValue = null) => {
    const bodyData = {
      ...(packingLineId && { packing_line_id: packingLineId }),
      ...(searchValue && { name: searchValue }),
      page: 1,
      per_page: 100,
    };
    const response = await getData(PACKING_TABLE_ENDPOINT, false, bodyData);
    if (response?.status === 200 || response?.code === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setPackingTablesList(data);
    }
  }, []);

  const getOperators = useCallback(async (searchValue = null) => {
    const bodyData = {
      ...(searchValue && { name: searchValue }),
      page: 1,
      per_page: 100,
    };
    const response = await getData(GET_DIGITALIZATION_APP_USERS, false, bodyData);
    if (response?.data?.code === 200 || response?.status === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setOperatorsList(data);
    }
  }, []);

  const getSalesContracts = useCallback(async (searchValue = null) => {
    const bodyData = {
      ...(searchValue && { reference_no: searchValue }),
      page: 1,
      per_page: 100,
    };
    const response = await getData(SALES_CONTRACT_LIST, false, bodyData);
    if (response?.data?.code === 200 || response?.status === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setSalesContractList(data);
    }
  }, []);

  const getBuyingOffices = useCallback(async (searchValue = null) => {
    const bodyData = {
      ...(searchValue && { name: searchValue }),
      page: 1,
      per_page: 100,
    };
    const response = await getData(GET_BUYING_OFFICE_ENDPOINT, false, bodyData);
    if (response?.status === 200 || response?.code === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setBuyingOfficeList(data);
    }
  }, []);

  const getBuyers = useCallback(async (searchValue = null) => {
    const bodyData = {
      ...(searchValue && { name: searchValue }),
      page: 1,
      per_page: 100,
    };
    const response = await getData(GET_BUYER_ENDPOINT, false, bodyData);
    if (response?.status === 200 || response?.code === 200) {
      const data = response?.data?.data?.data || response?.data?.data || [];
      setBuyerList(data);
    }
  }, []);

  // Fetch edit data when in edit mode
  const getEditData = useCallback(
    async (getPackingTablesFn) => {
      if (!id || !isEdit) return;

      setLoading(true);
      try {
        const response = await getData(`${HOURLY_PACKING_EDIT_ENDPOINT}/${id}`);

        if (response?.data?.code === 200 || response?.status === 200) {
          const data = response?.data?.data || response?.data;
          const record = data?.record;
          const cartons = data?.cartons || [];

          setEditRecord(record);

          // Add selected items to dropdown lists if not present
          setPackingLinesList((prev) => {
            if (record?.packing_line_info && !prev.find((l) => l.id === record.packing_line_info.id)) {
              return [record.packing_line_info, ...prev];
            }
            return prev;
          });
          setPackingTablesList((prev) => {
            if (record?.packing_table_info && !prev.find((t) => t.id === record.packing_table_info.id)) {
              return [record.packing_table_info, ...prev];
            }
            return prev;
          });
          setOperatorsList((prev) => {
            if (record?.operator_info && !prev.find((o) => o.id === record.operator_info.id)) {
              return [record.operator_info, ...prev];
            }
            return prev;
          });
          setSalesContractList((prev) => {
            if (record?.sales_contract_info && !prev.find((s) => s.id === record.sales_contract_info.id)) {
              return [
                { id: record.sales_contract_info.id, reference_no: record.sales_contract_info.reference_no },
                ...prev,
              ];
            }
            return prev;
          });
          setBuyingOfficeList((prev) => {
            if (record?.buying_office_info && !prev.find((b) => b.id === record.buying_office_info.id)) {
              return [record.buying_office_info, ...prev];
            }
            return prev;
          });
          setBuyerList((prev) => {
            if (record?.buyer_info && !prev.find((b) => b.id === record.buyer_info.id)) {
              return [record.buyer_info, ...prev];
            }
            return prev;
          });

          // Fetch packing tables for the selected packing line
          if (record?.packing_line_id && getPackingTablesFn) {
            getPackingTablesFn(record.packing_line_id);
          }

          // Set form values from record
          PackConfirmForm.setFieldsValue({
            entry_date: record?.entry_date ? moment(record.entry_date) : moment(),
            hour: record?.hour,
            packing_line_id: record?.packing_line_id,
            packing_table_id: record?.packing_table_id,
            operator_id: record?.operator_id,
            sales_contract_id: record?.sales_contract_id,
            buying_office_id: record?.buying_office_id,
            buyer_id: record?.buyer_id,
            sub_contract_factory_id: record?.sub_contract_factory_id,
            po_map_id: record?.po_map_id,
            original_po: record?.po_map_info?.original_po,
            internal_po: record?.po_map_info?.internal_po,
            buying_office_name: record?.buying_office_info?.name,
            buyer_name: record?.buyer_info?.name,
            reference_no: record?.sales_contract_info?.reference_no,
            sub_contract_factory_name: record?.sub_contract_factory_info?.name || "",
          });

          setIsFactory(record?.sub_contract_factory_id ? true : false);

          // Transform cartons to match table structure
          const transformedCartons = cartons.map((carton) => {
            const colors = {};
            carton.size_ratio?.forEach((ratio) => {
              if (!colors[ratio.color_id]) {
                colors[ratio.color_id] = {
                  color_id: ratio.color_id,
                  color_name: ratio.color_info?.name,
                  sub_style_id: ratio.sub_style_id,
                  sub_style_no: ratio.sub_style_info?.sub_style_no,
                  sizes: [],
                  color_total: 0,
                };
              }
              colors[ratio.color_id].sizes.push({
                size_id: ratio.size_id,
                size_name: ratio.size?.name,
                quantity: ratio.qty,
                id: ratio.id,
              });
              colors[ratio.color_id].color_total += ratio.qty || 0;
            });

            return {
              id: carton.id,
              carton_id: carton.packing_carton_id,
              carton_no: carton.packing_carton_id,
              style_id: carton.style_info?.id,
              style_no: carton.style_info?.style_no,
              carton_total: carton.carton_garment_qty,
              status: carton.packing_status === "Packed" ? "1" : carton.packing_status === "Shipment" ? "2" : "0",
              colors: Object.values(colors),
            };
          });

          setCartonList(transformedCartons);

          // Set selected cartons based on status
          const selected = transformedCartons
            .filter((carton) => carton.status === "1" || carton.status === "2")
            .map((carton) => ({
              ...carton,
              status: String(carton.status),
            }));
          setSelectedCarton(selected);
        } else {
          HandleNotification("error", "bottomRight", "Error fetching packing confirmation data", null);
        }
      } catch (error) {
        console.error("Error fetching edit data:", error);
        HandleNotification("error", "bottomRight", "Error fetching packing confirmation data", null);
      } finally {
        setLoading(false);
      }
    },
    [id, isEdit, PackConfirmForm],
  );

  useEffect(() => {
    if (isEdit && id) {
      getEditData(getPackingTables);
    } else {
      // Parse query parameters from the URL for old edit flow
      const searchParams = new URLSearchParams(location.search);
      const queryParamsObj = {
        po_map_id: searchParams.get("po_map_id"),
        sales_contract_id: searchParams.get("sales_contract_id"),
        buying_office_id: searchParams.get("buying_office_id"),
        transaction_no_per_day: searchParams.get("transaction_no_per_day"),
        packing_date: searchParams.get("packing_date"),
        sub_contract_factory_id: searchParams.get("sub_contract_factory_id"),
      };

      if (queryParamsObj.po_map_id && isEdit) {
        getPackingProductInfo(queryParamsObj);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isEdit, location.search]);

  const getPackingConfirmList = async (po_map_id, start, end, packing_date) => {
    const query = `${PACKING_CONFIRMATION_LIST}`;
    const bodyData = {
      po_map_id: po_map_id,
      start: start,
      end: end,
      packing_date: packing_date,
    };
    const response = await postData(query, bodyData);

    if (response && response?.code === 200) {
      setCartonList(
        response?.data?.map((carton) => ({
          ...carton,
          carton_id: carton?.id,
          status: String(carton?.status),
        })),
      );
    } else {
      alertPop("error", "Something went wrong");
    }
  };

  useEffect(() => {
    // Get all PO List on first render
    getPOList();

    // Load dropdown data if in edit mode
    if (isEdit && id) {
      getPackingLines();
      getOperators();
      getSalesContracts();
      getBuyingOffices();
      getBuyers();
    }
  }, [isEdit, id, getPackingLines, getOperators, getSalesContracts, getBuyingOffices, getBuyers]);

  useEffect(() => {
    // Get carton list data for showing in table
    if (
      (po_map_id_watch || po_map_id_watch === 0) &&
      (start_watch || start_watch === 0) &&
      (end_watch || end_watch === 0) &&
      packing_date_watch &&
      !isEdit
    ) {
      getPackingConfirmList(po_map_id_watch, start_watch, end_watch, packing_date_watch);
    }
  }, [po_map_id_watch, start_watch, end_watch, packing_date_watch, isEdit]);

  const onChangeInternalPO = (value) => {
    const selectedPO = poList?.find((po) => po?.internal_po === value);
    selectedPO &&
      PackConfirmForm.setFieldsValue({
        original_po: selectedPO?.original_po,
        buying_office_name: selectedPO?.buying_office_name,
        buying_office_id: selectedPO?.buying_office_id,
        buyer_name: selectedPO?.buyer_name,
        buyer_id: selectedPO?.buyer_id,
        sales_contract_id: selectedPO?.sales_contract_id,
        reference_no: selectedPO?.reference_no,
        po_map_id: selectedPO?.id,
        sub_contract_factory_id: selectedPO?.sub_contract_factory_id,
        sub_contract_factory_name: selectedPO?.sub_contract_factory_name || "",
      });
    setIsFactory(selectedPO?.sub_contract_factory_id ? true : false);
  };

  const onChangeOriginalPO = (value) => {
    setIsSubmitting(false);
    const selectedPO = poList?.find((po) => po?.original_po === value);
    selectedPO &&
      PackConfirmForm.setFieldsValue({
        internal_po: selectedPO?.internal_po,
        buying_office_name: selectedPO?.buying_office_name,
        buying_office_id: selectedPO?.buying_office_id,
        buyer_name: selectedPO?.buyer_name,
        buyer_id: selectedPO?.buyer_id,
        sales_contract_id: selectedPO?.sales_contract_id,
        reference_no: selectedPO?.reference_no,
        po_map_id: selectedPO?.id,
        sub_contract_factory_id: selectedPO?.sub_contract_factory_id,
        sub_contract_factory_name: selectedPO?.sub_contract_factory_name || "",
      });
    setIsFactory(selectedPO?.sub_contract_factory_id ? true : false);
  };

  const onFinishPackingConfirm = async (values) => {
    console.log("onFinishPackingConfirm values", values);

    setIsSubmitting(true);

    if (isEdit && id) {
      // New edit flow with hourly packing update endpoint
      const bodyData = {
        id: Number(id),
        entry_date: values?.entry_date ? moment(values.entry_date).format("YYYY-MM-DD") : null,
        hour: values?.hour || null,
        packing_line_id: values?.packing_line_id || null,
        packing_table_id: values?.packing_table_id || null,
        operator_id: values?.operator_id || null,
        sales_contract_id: values?.sales_contract_id || null,
        buying_office_id: values?.buying_office_id || null,
        buyer_id: values?.buyer_id || null,
        po_map_id: values?.po_map_id || null,
        sub_contract_factory_id: values?.sub_contract_factory_id || null,
        cartons: selectedCarton?.map((carton) => {
          const sizeRatio = [];
          carton.colors?.forEach((color) => {
            color.sizes?.forEach((size) => {
              sizeRatio.push({
                color_id: color.color_id,
                size_id: size.size_id,
                sub_style_id: color.sub_style_id,
                qty: size.quantity,
              });
            });
          });

          return {
            id: carton.id,
            packing_carton_id: carton.carton_id,
            style_id: carton.style_id,
            status: carton.status === "1" ? "Packed" : carton.status === "2" ? "Shipment" : "Unpacked",
            size_ratio: sizeRatio,
          };
        }),
      };

      const response = await postData(HOURLY_PACKING_UPDATE_ENDPOINT, bodyData);

      if (response?.code === 200 || response?.status === 200) {
        HandleNotification("success", "bottomRight", "Packing Confirmation Updated Successfully", null);
        navigate("/digitalization/packing/confirmation");
      } else {
        HandleNotification("error", "bottomRight", response?.message || "Error updating packing confirmation", null);
      }
    } else {
      // Original create flow
      const query = `${PACKING_CONFIRM}`;
      const bodyData = {
        po_map_id: values?.po_map_id || null,
        buying_office_id: values?.buying_office_id || null,
        sales_contract_id: values?.sales_contract_id || null,
        sub_contract_factory_id: values?.sub_contract_factory_id || null,
        packing_date: moment(values?.packing_date).format("YYYY-MM-DD"),
        buyer_id: buyer_id_watch || null,
        cartons: selectedCarton?.map((carton) => ({
          ...carton,
          carton_id: carton?.carton_id,
          status: Number(carton?.status),
        })),
      };

      const response = await postData(query, bodyData);

      if (response) {
        alertPop("success", response?.message || "Packing Confirmed!");
        setSelectedCarton([]);
        getPackingConfirmList(po_map_id_watch, start_watch, end_watch);
      }
    }

    setIsSubmitting(false);
  };

  return (
    <>
      <InventoryLayOutCommon>
        <AppPageHeader title={<Title level={5}>Packing Confirmation</Title>} extra={extra} />
        <Content className="item-details">
          <Collapse defaultActiveKey={["1"]} style={{ marginTop: 10 }}>
            <Panel header={<b>Packing Confirmation Entry</b>} key="1">
              <Form layout="vertical" onFinish={onFinishPackingConfirm} form={PackConfirmForm}>
                <HourlyPackingConfirmationForm
                  form={PackConfirmForm}
                  poList={poList}
                  onChangeInternalPO={onChangeInternalPO}
                  onChangeOriginalPO={onChangeOriginalPO}
                  isEdit={isEdit}
                  isFactory={isFactory}
                  editRecord={editRecord}
                  loading={loading}
                  packingLinesList={packingLinesList}
                  packingTablesList={packingTablesList}
                  operatorsList={operatorsList}
                  salesContractList={salesContractList}
                  buyingOfficeList={buyingOfficeList}
                  buyerList={buyerList}
                  getPackingLines={getPackingLines}
                  getPackingTables={getPackingTables}
                  getOperators={getOperators}
                  getSalesContracts={getSalesContracts}
                  getBuyingOffices={getBuyingOffices}
                  getBuyers={getBuyers}
                />
              </Form>
            </Panel>
          </Collapse>
          <HourlyPackingConfirmationTable
            isEdit={isEdit}
            cartonList={cartonList}
            selectedCarton={selectedCarton}
            setSelectedCarton={setSelectedCarton}
          />
        </Content>
      </InventoryLayOutCommon>
    </>
  );
};

export default HourlyPackingConfirmation;
